import {
  Currency,
  Locale,
  Price,
  TripBookColor,
  TripBookLanguage,
  TripBookPrice,
  TripBookRemoteConstants,
  TripBookShippingDiscount
} from '51trips-frontend-core'
import { DocumentData, DocumentSnapshot } from 'firebase/firestore'

import { AppLanguages } from '../../constants/AppLanguages'
import tripBookColorConverter from './TripBookColorConverter'
import tripBookLanguageConverter from './TripBookLanguageConverter'
import tripBookShippingDiscountConverter from './TripBookShippingDiscountConverter'

const tripBookRemoteConstantsConverter = {
  fromFirestore: (
    snapshot: DocumentSnapshot<DocumentData, DocumentData>,
    locales: Locale[],
    currency: Currency
  ) => {
    const data = snapshot.data()
    if (data) {
      let tripBookPreviewURL: string | undefined
      if (data.localizedTripBookPreviewURL[locales[0].languageCode]) {
        tripBookPreviewURL = data.localizedTripBookPreviewURL[locales[0].languageCode]
      } else {
        tripBookPreviewURL = data.localizedTripBookPreviewURL[AppLanguages.es]
      }

      const shippingCountriesNumericCodes: string[] = []
      if (Array.isArray(data.shippingCountriesNumericCodes)) {
        for (const shippingCountriesNumericCode of data.shippingCountriesNumericCodes) {
          if (typeof shippingCountriesNumericCode === 'string') {
            shippingCountriesNumericCodes.push(shippingCountriesNumericCode)
          }
        }
      }

      const tripBookColors: TripBookColor[] = []
      if (Array.isArray(data.tripBookColors)) {
        for (const tripBookColorData of data.tripBookColors) {
          const tripBookColor = tripBookColorConverter.fromFirestore(tripBookColorData)
          if (tripBookColor) {
            tripBookColors.push(tripBookColor)
          }
        }
      }

      const tripBookLanguages: TripBookLanguage[] = []
      if (Array.isArray(data.tripBookLanguages)) {
        for (const tripBookLanguageData of data.tripBookLanguages) {
          const tripBookLanguage = tripBookLanguageConverter.fromFirestore(tripBookLanguageData)
          if (tripBookLanguage) {
            tripBookLanguages.push(tripBookLanguage)
          }
        }
      }

      const tripBookPrices: TripBookPrice[] = []
      if (Array.isArray(data.tripBookColors)) {
        for (const tripBookPriceData of data.tripBookPrices) {
          if (
            typeof tripBookPriceData.price === 'object' &&
            typeof tripBookPriceData.pages === 'number'
          ) {
            const value = tripBookPriceData.price[currency]
            if (value) {
              tripBookPrices.push(
                new TripBookPrice(new Price(currency, value), tripBookPriceData.pages)
              )
            }
          }
        }
      }

      const tripBookShippingDiscounts: TripBookShippingDiscount[] = []
      if (Array.isArray(data.tripBookShippingDiscounts)) {
        for (const tripBookShippingDiscountData of data.tripBookShippingDiscounts) {
          const tripBookShippingDiscount = tripBookShippingDiscountConverter.fromFirestore(
            tripBookShippingDiscountData
          )
          if (tripBookShippingDiscount) {
            tripBookShippingDiscounts.push(tripBookShippingDiscount)
          }
        }
      }

      let tripBookDefaultShippingDiscount = { [Currency.eur]: 0.0 }
      if (typeof data.tripBookDefaultShippingDiscount === 'object') {
        tripBookDefaultShippingDiscount = data.tripBookDefaultShippingDiscount
      }

      let imagePatternAfterSixth: number[] = []
      if (Array.isArray(data.imagePatternAfterSixth)) {
        imagePatternAfterSixth = data.imagePatternAfterSixth
      }

      return new TripBookRemoteConstants(
        tripBookPreviewURL,
        shippingCountriesNumericCodes,
        tripBookColors,
        tripBookLanguages,
        tripBookPrices,
        tripBookShippingDiscounts,
        tripBookDefaultShippingDiscount,
        imagePatternAfterSixth
      )
    } else {
      return undefined
    }
  }
}

export default tripBookRemoteConstantsConverter
